import Image from "next/image";
import Link from "next/link";
import { routes } from "@/lib/links";

const navLinks = [
  { href: routes.shop, label: "Shop" },
  { href: routes.free, label: "Free sample" },
  { href: routes.licence, label: "Licence" },
];

export function ComingSoonHeader() {
  return (
    <header className="mx-auto flex max-w-[1200px] flex-wrap items-center gap-y-2 px-5 pt-5 sm:flex-nowrap sm:px-8 sm:pt-7">
      <Link href={routes.home} aria-label="Carnies" className="mr-auto flex items-center">
        <Image
          src="/brand/carnies.svg"
          alt="carnies."
          width={320}
          height={88}
          priority
          className="h-10 w-auto sm:h-14"
        />
      </Link>
      {/* On phones the links drop to their own row (order-3) so the CTA
          stays beside the logo in the top row. */}
      <nav aria-label="Main" className="order-3 w-full sm:order-none sm:mr-6 sm:w-auto">
        <ul className="flex flex-wrap items-center gap-x-5 gap-y-1 text-sm font-semibold sm:gap-x-6 sm:text-[15px]">
          {navLinks.map((l) => (
            <li key={l.href}>
              <Link href={l.href} className="inline-block py-2 transition-colors hover:text-brand">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <Link
        href={`${routes.home}#join`}
        className="rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#0742a8] sm:px-6 sm:py-3 sm:text-[15px]"
      >
        Notify me
      </Link>
    </header>
  );
}
